// utils/excel.js
import * as XLSX from 'xlsx';

// 直接定義員工表的匯出欄位配置
const employeeExportFields = {
    'e_id': 'ID',
    'e_ssid': '社別ID',
    'e_position': '社職ID',
    'e_sex': '性別',
    'e_name': '姓名',
    'e_mobile': '手機',
    'e_email': '個人電子信箱',
    'e_birthday': '生日',
    'e_tel': '住宅電話',  
    'e_zip': '住宅郵編',
    'e_address': '住宅地址',
    'e_zip2': '通訊郵編',
    'e_address2': '通訊地址',
    'e_tel1': '公司電話',
    'e_fax': '公司傳真',
    'e_comp_name': '公司名稱',
    'e_comp_position': '公司職稱',
    'e_zip1': '公司郵編',
    'e_address1': '公司地址',
    'e_comp_web': '公司網站',
    'e_email': '公司電子信箱',
    'sql_title4': '營業內容',
    'e_join_date': '入社時間',
    'e_foodType': '葷素食',
    'ss_name': '社別名稱',
    's_name': '職位名稱',
    'e_set': '組別',
    'e_set_position': '組別職位',
    'e_group': '社友類別',
    'e_photo': '照片',
    'EDM_photo': 'EDM 照片',
    'e_status': '狀態'
};

export const downloadExcel = async (data, tableName, fileName = '資料.xlsx') => {
    try {
        // 根據表名選擇對應的欄位配置
        let exportFields = {};
        
        if (tableName === 'employees') {
            exportFields = employeeExportFields;
        } else {
            // 如果是其他表，直接使用資料的欄位名稱作為標題
            exportFields = data.length > 0 ? 
                Object.keys(data[0]).reduce((acc, key) => {
                    acc[key] = key;
                    return acc;
                }, {}) : {};
        }

        // 數值轉換函數
        const convertFieldValue = (field, value, item) => {
            switch (field) {
                case 'e_sex':
                    return value === 1 ? '男性' : value === 2 ? '女性' : value;
                
                case 'e_foodType':
                    return value === 1 ? '葷食' : value === 2 ? '素食' : value;
                
                case 'e_ssid':
                    // 優先使用社別名稱 (支援不同的欄位名稱)
                    return item.ss_name || item.store_name || value;
                
                case 'e_position':
                    // 優先使用職位名稱 (支援不同的欄位名稱)
                    return item.s_name || item.position_title || value;
                
                case 'e_status':
                    return value === 0 ? '啟用' : value === 1 ? '停用' : value;
                
                case 'e_group':
                    // 社友類別轉換
                    const groupNames = {
                        1: '創社社友',
                        2: '榮譽社友', 
                        3: '永久榮譽社友',
                        4: '贊助社友',
                        5: '正式社友',
                        6: '家屬'
                    };
                    return groupNames[value] || value;
                
                default:
                    return value;
            }
        };

        let filteredData;
        
        if (tableName === 'employees') {
            // 員工表需要欄位轉換
            filteredData = data.map(item => {
                const filteredItem = {};
                for (const field in exportFields) {
                    if (item.hasOwnProperty(field)) {
                        const convertedValue = convertFieldValue(field, item[field], item);
                        filteredItem[exportFields[field]] = convertedValue; // 使用轉換後的值和中文標題
                    }
                }
                return filteredItem;
            });
        } else {
            // 其他表直接使用原始資料
            filteredData = data;
        }

        // 將資料轉換為工作表
        const worksheet = XLSX.utils.json_to_sheet(filteredData);

        // 建立一個工作簿
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, '資料');

        // 生成 Excel 檔案
        XLSX.writeFile(workbook, fileName);
        
        console.log(`✅ Excel 匯出成功：${fileName}`);
    } catch (error) {
        console.error('❌ Excel 匯出失敗:', error);
        throw error;
    }
};

// 通用的Excel匯出函數
export const exportToExcel = (data, fileName = '資料') => {
    try {
        // 確保檔名包含 .xlsx 副檔名
        const finalFileName = fileName.endsWith('.xlsx') ? fileName : `${fileName}.xlsx`;
        
        // 將資料轉換為工作表
        const worksheet = XLSX.utils.json_to_sheet(data);
        
        // 建立一個工作簿
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, '資料');
        
        // 生成 Excel 檔案
        XLSX.writeFile(workbook, finalFileName);
        
        console.log(`✅ Excel 匯出成功：${finalFileName}`);
        return true;
    } catch (error) {
        console.error('❌ Excel 匯出失敗:', error);
        throw error;
    }
};
